import {logger} from "./loggingService";
import axios from "axios";
import bearerAxios from '../helpers/bearerAxios';
import {useViewerStore} from "../store/store";
import {SunnovaDesignArray, SunnovaEstimateRequest} from "../domain/models/http/requests/SunnovaEstimateRequest";
import {
    IGSDesignArray,
    IGSProductionEstimateRequest
} from "../domain/models/http/requests/IGSProductionEstimateRequest";
import { RoofMesh } from "../@types/types";

const baseURL: string = import.meta.env.VITE_BASE_URL!;
const SUNNOVA_ESTIMATE_API_URL: string = import.meta.env.VITE_PANDA_SUNNOVA_ESTIMATE_API_URL!;


const buildDesignArray = () => {

    const designArray: SunnovaDesignArray[] = []

    const sceneViewer = useViewerStore.getState().sceneViewer;
    const roofInfoArr = useViewerStore.getState().roofInfoArr;
    const activeModulePower = useViewerStore.getState().activeModule.power
    const activeModuleName = useViewerStore.getState().activeModule.text
    const moduleSplit = activeModuleName.split(' - ')
    const module_SF_ID = activeModuleName.split('-')[0].trim()
    const module_model = moduleSplit.slice(1).join(' ').trim()


    sceneViewer?.roofMeshArr.forEach((roofMesh: RoofMesh) => {

        const roof = roofInfoArr.find((roof: any) => roof.roofFaceId === roofMesh.roofFaceId)
        if (!roof) return
        const roofSolarAccess = roof.solarAccess
        const roofArraySize = roof.arraySize

        if (roofSolarAccess < 50) return

        if (!roofMesh?.moduleArr || roofMesh?.moduleArr?.length === 0) return

        designArray.push({
                "Design_Array_Ctr_Num": roofMesh.userData.roof_tag_id,
                "Module_Manufacturer_SF_ID": module_SF_ID,
                "Module_Model_TS_SF_Id": module_model,
                "Module_Wattage": activeModulePower,
                "Module_Qty": roofMesh?.moduleArr?.length || 0,
                "Array_Size": Number(roofArraySize),
                "Tilt": Math.round(roofMesh.oriAng.tilt),
                "Azimuth": Math.round(roofMesh.oriAng.azimuth),
                "Shading_coeffecient": roofSolarAccess
            }
        )
    })
    return designArray;

}


export const buildSunnovaEstimatePayload = () : SunnovaEstimateRequest => {

    const sceneViewer = useViewerStore.getState().sceneViewer;
    const {latitude, longitude} = sceneViewer?.mapCoordinates;
    const addressComponents = sceneViewer?.addressInfo;
    const fullAddress = useViewerStore.getState().siteAddress

    return {
        "User_Key": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        "Opportunity_SalesForce_ID": String(sessionStorage.getItem('SalesForceId')),
        "Latitude": String(latitude.toFixed(6)),
        "Longitude": String(longitude.toFixed(6)),
        "Installation_Street": fullAddress,
        "Installation_City": addressComponents?.city,
        "Installation_State": String(sessionStorage.getItem('stateCode')),
        "Installation_Zip": String(sessionStorage.getItem('postalCode')),
        "Design_Array": buildDesignArray()
    }
}


const getSunnovaEstimate = async () => {

    const payload: SunnovaEstimateRequest = buildSunnovaEstimatePayload();

    return await axios.post(SUNNOVA_ESTIMATE_API_URL, payload)
        .then(response => {
            return  Number(response.data.totalProduction/1000).toFixed(2) || 0;
        })
        .catch(error => {
            logger.error(error);
            throw Error(String(error.response.data))
        })
}


const getIGSEstimate = async () => {

    const sceneViewer = useViewerStore.getState().sceneViewer;
    const totalSystemSize = useViewerStore.getState().totalSystemSize;
    const activeModuleName = useViewerStore.getState().activeModule.text
    const {latitude, longitude} = sceneViewer?.mapCoordinates;
    const roofInfoArr = useViewerStore.getState().roofInfoArr;

    const designArray: IGSDesignArray[] = []

    sceneViewer?.roofMeshArr.forEach((roofMesh: any) => {

        const roofInfo = roofInfoArr.find((roof: any) => roof.roofFaceId === roofMesh.roofFaceId)
        if (!roofInfo) return

        if (!roofMesh?.moduleArr || roofMesh?.moduleArr?.length === 0) return

        designArray.push({
            "roofTagId": Number(roofMesh.userData.roof_tag_id),
            "tilt": Math.round(roofMesh.oriAng.tilt),
            "azimuth": Math.round(roofMesh.oriAng.azimuth),
            "moduleCount": roofMesh?.moduleArr?.length || 0,
            "annualProduction": Math.round(Number(roofInfo.actual_production)),
            "unshadedPercent": roofInfo.solarAccess,
            "efficiency": Number(roofInfo.efficiency),
            "tof": Number(roofInfo.roofMultiplier.toFixed(2))
        })
    })

    const payload: IGSProductionEstimateRequest = {
        "latitude": Number(latitude.toFixed(6)),
        "longitude": Number(longitude.toFixed(6)),
        "moduleType": activeModuleName,
        "systemSize": totalSystemSize,
        "array": designArray
    }

    return await bearerAxios.post(baseURL + import.meta.env.VITE_GET_IGS_PRODUCTION_ESTIMATE, payload, {
        headers: {
            ContentType: 'application/json',
        }
    })
        .then(response => {
            return Number(response.data.AnnualProduction/1000).toFixed(2) || 0;
        })
        .catch(error => {
            logger.error(error);
            console.log(error.response.data)
            throw Error(String(error.response.data))
        })
}

export const productionEstimateService = {
    getSunnovaEstimate,
    getIGSEstimate
}
